import { useEffect } from "react";

/**
 * Applies a v2 theme choice to the document root.
 *
 * "auto" (or undefined) removes the attribute so the prefers-color-scheme block in tokens.css takes
 * over; anything else stamps data-theme, which the token overrides are written to win over the
 * system preference in both directions. Storage stays with the caller — the cab and the console
 * deliberately remember their choices under different keys, because a driver's phone and a
 * director's laptop are different contexts even when it's the same person.
 */
export function useDocumentTheme(theme: string | undefined): void {
    useEffect(() => {
        if (!theme || theme === "auto") document.documentElement.removeAttribute("data-theme");
        else document.documentElement.setAttribute("data-theme", theme);
    }, [theme]);
}
